import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reports-intermediate',
  templateUrl: './reports-intermediate.component.html',
  styleUrls: ['./reports-intermediate.component.scss']
})
export class ReportsIntermediateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
